<template>
    <!-- <h2>Weekly Coding Challenge #1: Sign in/up Form</h2> -->
    <div class="center">
		<Toast />

<div class="container-div" style="" id="container">
	<div class="form-container sign-up-container">
		<!-- <form> -->
			<div class="form">
			<h1>Create Account</h1>
			<!-- <div class="social-container">
				<a href="#" class="social"><i class="fab fa-facebook-f"></i></a>
				<a href="#" class="social"><i class="fab fa-google-plus-g"></i></a>
				<a href="#" class="social"><i class="fab fa-linkedin-in"></i></a>
			</div> -->
			<span>or use your email for registration</span>
			<input type="text" placeholder="Name" />
			<input type="email" placeholder="Email" />
			<input type="password" placeholder="Password" />
			<button>Sign Up</button>
		<!-- </form> -->
			</div>
	</div>
	<div class="form-container sign-in-container">
		<div class="form">
			
		<!-- <form > -->
			<h1>Sign in</h1>
			<!-- <div class="social-container">
				<a href="#" class="social"><i class="fab fa-facebook-f"></i></a>
				<a href="#" class="social"><i class="fab fa-google-plus-g"></i></a>
				<a href="#" class="social"><i class="fab fa-linkedin-in"></i></a>
			</div> -->
			<!-- <span>or use your account</span> -->
			<input type="email" v-model="email" placeholder="Email" />
			<input type="password" v-model="password" placeholder="Password" @keypress.enter="Login" />
			<!-- <a href="#">Forgot your password?</a> -->
			<button @click="Login">Sign In</button>
		<!-- </form> -->
		</div>
	</div>
	<div class="overlay-container">
		<div class="overlay">
			<div class="overlay-panel overlay-left">
				<h1>Welcome Back!</h1>
				<p>To keep connected with us please login with your personal info</p>
				<button class="ghost" id="signIn"  >Sign In</button>
			</div>
			<div class="overlay-panel overlay-right">
				<h1>Hello, Friend!</h1>
				<p>Enter your personal details and start journey with us</p>
				<!-- <button class="ghost" id="signUp">Sign Up</button> -->
			</div>
		</div>
	</div>
</div>
    </div>

</template>
<script>
import apis from "@/apis";
export default {
    data() {
        return {
            isLoadingModel:false,
			fullPage:true,
            email: '',
            password: '',
            checked: false,
            show:false,
            user_type:'',
        }
    },
    methods:{
    async  Login(e)
      {
        // alert("here");
		// e.preventDefalut();
		// return
        if(this.email==="" ||this.email===null ||this.email===undefined)
        {
            //alert("Please Enter Username");
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Please Enter Username', life: 3000});
            return false;
        }
        if(this.password==="" ||this.password===null ||this.password===undefined)
        {
            //alert("Please Enter Password");
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Please Enter Password', life: 3000});
            return false;
        }
        
        var data = 
         {
                "email_id":this.email,  
                "password":this.password, 
         };
         this.isLoadingModel = true;
		var promise = apis.login(data);
        promise
        .then(response => { 
            this.isLoadingModel = false;
        if(response.data.status==true)
        {   
            localStorage.clear();
            
            localStorage.user_key = response.data.data[0].user_type;
            localStorage.id = response.data.data[0]._id;
            localStorage.token = response.data.data[0].logintoken;
            localStorage.client_id = response.data.data[0].client_id?response.data.data[0].client_id:'';

            localStorage.state_code     = response.data.data[0].state_code      ?response.data.data[0].state_code:[];
            localStorage.district_id    = response.data.data[0].district_id     ?response.data.data[0].district_id:[];
            localStorage.block_id       = response.data.data[0].block_id        ?response.data.data[0].block_id:[];
            localStorage.panchayat_id    = response.data.data[0].panchayat_id     ?response.data.data[0].panchayat_id:[];
            localStorage.village_id     = response.data.data[0].village_id      ?response.data.data[0].village_id:[];           

            localStorage.client_name = '';
           
            if (response.data.data[0].client_details && response.data.data[0].client_details.length>0) 
            {
                localStorage.client_name = response.data.data[0].client_details[0].description;
            }
            if (response.data.data[0].client_group_details && response.data.data[0].client_group_details.length>0) 
            {   
                localStorage.client_name = response.data.data[0].client_group_details[0].group_name;
                localStorage.group_name = response.data.data[0].client_group_details[0].group_name;
               
                //localStorage.client_group_ids=response.data.data[0].client_group_details[0].client_ids;
                localStorage.setItem('client_group_ids', JSON.stringify(response.data.data[0].client_group_details[0].client_ids));
                
            }
            else
            {
                localStorage.setItem('client_group_ids', '');
            }
            
            //for fleet manager
            localStorage.role_id = response.data.data[0].role_id[0].role_id;

            localStorage.setItem('user_profile',JSON.stringify(response.data.data[0]));

            
            this.$store.dispatch("setClients",   response.data.data[0]);
            this.$store.dispatch("setUserTypes", response.data.data[0].client_id);           
            this.$store.dispatch("setDistricts", response.data.data[0]);
            this.$store.dispatch("setBlocks",    []);
            // this.$store.dispatch("setPanchyats", []);
            this.$store.dispatch("setGarbageCenterType", []);
            //this.$store.dispatch("setVillages",  response.data.data[0]); // api error for all village data 
            
            var dashboard_link="";
           if (response.data.data[0].role_id && response.data.data[0].role_id[0].dashboard_link) 
           {  
             dashboard_link=response.data.data[0].role_id[0].dashboard_link.toString();

            localStorage.Breadcrumb_home = dashboard_link;  //for Breadcrumb_home

            this.$router.push({name:dashboard_link});
            
           }
           else
           {
              dashboard_link = '/dashboard';                    //for Breadcrumb_home
              localStorage.Breadcrumb_home = dashboard_link;    //for Breadcrumb_home

            this.$router.push('/dashboard');
           }
            


            //*****************************************************************************************************
            // if(this.user_type.value == "admin")
            // {
            //      localStorage.token = response.data["token"]; // user type id
            //      localStorage.id = response.data.admindata["admiN_ID"];
            //      localStorage.full_name = response.data.admindata["firsT_NAME"];  
            //      localStorage.email = response.data.admindata["email"]; 
            //     //  this.$session.start();
            //     // this.$session.set("token", token);
               
            //     this.$router.push('/dashboard');
            // }
            // else if(this.user_type.value == "teacher") 
            // {
            //      localStorage.token = response.data["token"];
            //      localStorage.id = response.data.teacherdata["teacheR_ID"];
            //      localStorage.full_name = response.data.teacherdata["firsT_NAME"];
            //      localStorage.email = response.data.teacherdata["email"]; 

            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'Teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/teacherhome');
            // }
            // else if(this.user_type.value == "assteacher") 
            // {      
            //     localStorage.id = response.data.teacherdata["teacheR_ID"];
            //     localStorage.token = response.data["token"];
            //     localStorage.full_name = response.data.teacherdata["firsT_NAME"];
            //     localStorage.email = response.data.teacherdata["email"]; 
            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'assistant_teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/ateacherhome');
            // }
            // else if(this.user_type.value == "network") 
            // {      
            //     localStorage.id = response.data.networkuserdata["id"];
            //     localStorage.token = response.data["token"];
            //     localStorage.full_name = response.data.networkuserdata["name"];
            //     localStorage.email = response.data.networkuserdata["email"]; 
            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'assistant_teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/dashboard');
            // }
            // else if(this.user_type.value == "student") 
            // {      
            //     localStorage.id = response.data.studentdata["studenT_ID"];
            //     localStorage.token = response.data["token"];
            //     localStorage.full_name = response.data.studentdata["firsT_NAME"]+" "+response.data.studentdata["surname"];
            //     localStorage.email = response.data.studentdata["email"]; 
            //     localStorage.mobile = response.data.studentdata["mobile"]; 
            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'assistant_teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/studentdashboard');
            // }
        } 
        else  
        {
              this.$toast.add({severity:'error', summary: 'Error Message', detail:response.data.message, life: 3000});
            return false;
        }  
            
            
        })
        .catch(error => {
            this.isLoadingModel = false;
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Invalid Login Credentials', life: 3000});
            return false;
            });
      }  
    },
    computed: {
        logoColor() {
            if (this.$appState.darkTheme) return 'white';
            return 'dark';
        }
    }
}
</script>
<style scoped>
    
/* @import url('https://fonts.googleapis.com/css?family=Montserrat:400,800'); */

* {
	box-sizing: border-box;
}
/* .center {  */
  /* height: 200px; */
  /* position: relative; */
  /* border: 3px solid green;  */
/* } */

.center .container-div {
  /* margin: 0; */
  position: absolute;
  top: 50%;
  left: 50%;
  vertical-align: middle;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

body {
	background: #f6f5f7;
	/* display: flex; */
	/* justify-content: center; */
	/* align-items: center; */
	/* flex-direction: column; */
	/* font-family: 'Montserrat', sans-serif; */
	/* height: 100vh; */
	/* margin: -20px 0 50px; */
}

h1 {
	font-weight: bold;
	margin: 0;
}

h2 {
	text-align: center;
}

p {
	font-size: 14px;
	font-weight: 100;
	line-height: 20px;
	letter-spacing: 0.5px;
	margin: 20px 0 30px;
}

span {
	font-size: 12px;
}

a {
	color: #333;
	font-size: 14px;
	text-decoration: none;
	margin: 15px 0;
}

button {
	border-radius: 20px;
	border: 1px solid #FF4B2B;
	background-color: #FF4B2B;
	color: #FFFFFF;
	font-size: 12px;
	font-weight: bold;
	padding: 12px 45px;
	letter-spacing: 1px;
	text-transform: uppercase;
	transition: transform 80ms ease-in;
}

button:active {
	transform: scale(0.95);
}

button:focus {
	outline: none;
}

button.ghost {
	background-color: transparent;
	border-color: #FFFFFF;
}

.form {
	background-color: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 50px;
	height: 100%;
	text-align: center;
}

input {
	background-color: #eee;
	border: none;
	padding: 12px 15px;
	margin: 8px 0;
	width: 100%;
}

.container-div {
    vertical-align: middle;

	background-color: #fff;
	border-radius: 10px;
  	box-shadow: 0 14px 28px rgba(0,0,0,0.25), 
			0 10px 10px rgba(0,0,0,0.22);
	position: absolute;
	overflow: hidden;
	width: 768px;
    text-align: center;
	max-width: 100%;
	min-height: 480px;
}

.form-container {
	position: absolute;
	top: 0;
	height: 100%;
	transition: all 0.6s ease-in-out;
}

.sign-in-container {
	left: 0;
	width: 50%;
	z-index: 2;
}

.container-div.right-panel-active .sign-in-container {
	transform: translateX(100%);
}

.sign-up-container {
	left: 0;
	width: 50%;
	opacity: 0;
	z-index: 1;
}

.container-div.right-panel-active .sign-up-container {
	transform: translateX(100%);
	opacity: 1;
	z-index: 5;
	animation: show 0.6s;
}

@keyframes show {
	0%, 49.99% {
		opacity: 0;
		z-index: 1;
	}
	
	50%, 100% {
		opacity: 1;
		z-index: 5;
	}
}

.overlay-container {
	position: absolute;
	top: 0;
	left: 50%;
	width: 50%;
	height: 100%;
	overflow: hidden;
	transition: transform 0.6s ease-in-out;
	z-index: 100;
}

.container-div.right-panel-active .overlay-container{
	transform: translateX(-100%);
}

.overlay {
	background: #FF416C;
	background: -webkit-linear-gradient(to right, #FF4B2B, #FF416C);
	background: linear-gradient(to right, #FF4B2B, #FF416C);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 0 0;
	color: #FFFFFF;
	position: relative;
	left: -100%;
	height: 100%;
	width: 200%;
  	transform: translateX(0);
	transition: transform 0.6s ease-in-out;
}

.container-div.right-panel-active .overlay {
  	transform: translateX(50%);
}

.overlay-panel {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 40px;
	text-align: center;
	top: 0;
	height: 100%;
	width: 50%;
	transform: translateX(0);
	transition: transform 0.6s ease-in-out;
}

.overlay-left {
	transform: translateX(-20%);
}

.container-div.right-panel-active .overlay-left {
	transform: translateX(0);
}

.overlay-right {
	right: 0;
	transform: translateX(0);
}

.container-div.right-panel-active .overlay-right {
	transform: translateX(20%);
}

.social-container {
	margin: 20px 0;
}

.social-container a {
	border: 1px solid #DDDDDD;
	border-radius: 50%;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	margin: 0 5px;
	height: 40px;
	width: 40px;
}

footer {
    background-color: #222;
    color: #fff;
    font-size: 14px;
    bottom: 0;
    position: fixed;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 999;
}

footer p {
    margin: 10px 0;
}

footer i {
    color: red;
}

footer a {
    color: #3c97bf;
    text-decoration: none;
}
</style>